import { useEffect, useState } from 'react';
import { useEvent, useLazyCommand } from '@soap/modules';

/** Tenant learning-style catalog (C253) — cached for the tab after first load. */
let cachedLearningStyles: unknown[] | null = null;
let fetchStarted = false;

/**
 * Loads the learning-styles catalog when `enabled` (e.g. Create Unit wizard open).
 * Avoids C253 on every Plan page load.
 */
export function useLearningStylesCatalog(enabled: boolean): unknown[] {
  const [learningStyles, setLearningStyles] = useState<unknown[]>(
    () => cachedLearningStyles ?? []
  );
  const [sendGetLearningStyles] = useLazyCommand('C253v1_GetLearningStyles', null);

  useEvent({
    eventName: 'E180v1_GotLearningStyles',
    onEventReceived: (event: { e180_LearningStyles?: unknown[] }) => {
      if (event?.e180_LearningStyles) {
        cachedLearningStyles = event.e180_LearningStyles;
        setLearningStyles(event.e180_LearningStyles);
      }
    },
  });

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (cachedLearningStyles) {
      setLearningStyles(cachedLearningStyles);
      return;
    }
    if (fetchStarted) {
      return;
    }
    fetchStarted = true;
    sendGetLearningStyles({});
  }, [enabled, sendGetLearningStyles]);

  return learningStyles;
}
